import React from 'react';
import AlertModalContainer from "./AlertModalContainer"
const AlertModal = (props) => (
    <AlertModalContainer {...props} />
);
export default AlertModal;
